// ICONS
import SearchIcon from '@mui/icons-material/Search'

export const AUCTION_TYPE = {
    online: "ONLINE",
    onsite: "ONSITE"
}

export const auctionStepList = [
    { 
        icons: <SearchIcon style={{ width: "40px", height: "40px" }} />,
        title: "Sign Up / Login di Aplikasi DjuBli",
        desc: "Buat sebuah akun baru atau login di Aplikasi DjuBli"
    },
    { 
        icons: <SearchIcon style={{ width: "40px", height: "40px" }} />,
        title: "Beli Token",
        desc: "Lakukan pembelian token / deposit dan masuk ke ruangan lelang"
    },
    { 
        icons: <SearchIcon style={{ width: "40px", height: "40px" }} />,
        title: "Pilih Lelang yang ingin kamu ikuti",
        desc: "Lihat unit yang kami tawarkan dan pilih sesuai keinginanmu"
    },
    { 
        icons: <SearchIcon style={{ width: "40px", height: "40px" }} />,
        title: "Masuk ke Bid Room",
        desc: "Pilih halaman Bid pada lelang yang sedang kamu ikuti"
    },
    { 
        icons: <SearchIcon style={{ width: "40px", height: "40px" }} />,
        title: "Lakukan Bid (Penawaran Harga)",
        desc: "Tawar / Bid unit yang sudah anda minati"
    },
    { 
        icons: <SearchIcon style={{ width: "40px", height: "40px" }} />,
        title: "Hasil Lelang",
        desc: "Setelah masa Lelang Selesai, kamu akan diberikan notifikasi melalui Email dan WA"
    },
]

export const auctionStepImageList = [
    { title: "sign-up-login", src: "/images/djubli_auction/step/1-login.png" },
    { title: "beli-token", src: "/images/djubli_auction/step/2-beli-token.png" },
    { title: "pilih-lelang", src: "/images/djubli_auction/step/3-pilih-lelang.png" },
    { title: "masuk-bid-room", src: "/images/djubli_auction/step/4-masuk-bid-room.png" },
    { title: "lakukan-bid", src: "/images/djubli_auction/step/5-lakukan-bid.png" },
    { title: "hasil-lelang", src: "/images/djubli_auction/step/6-hasil-lelang.png" },
]

export const auctionFaqList = [
    { 
        question: "Apa itu DjuBli Lelang?", 
        answer: "DjubliLelang adalah balai lelang yang bergerak pada lelang produk otomotif seperti kendaraan roda dua, roda empat sampai dengan alat berat. Berdiri sejak tahun 2021 sebelumnya DjuBli berfokus pada Platform Jual Beli kendaraan secara online, namun sejak 2023 berfokus kepada lelang otomotif.",
        customElementAnswer: false
    },
    { 
        question: "Kenapa Lelang di DjuBli?", 
        answer: "Kami mengedepankan digitalisasi, transpasi dan kemudahan pada siap transaksi jual beli dengan sistem lelang sehingga dapat diandalkan oleh seluruh pelanggan baik penitip unit lelang dan peserta lelang.",
        customElementAnswer: false
    },
    // { 
    //     question: "Kenapa Lelang di DjuBli", 
    //     answer: <>
    //         <Typography>
    //             <strong>Lelang di DjuBli</strong>
    //         </Typography>
    //         <Typography align='justify'>
    //             Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
    //         </Typography>
    //     </>,
    //     customElementAnswer: true
    // },
    { 
        question: "Bagaimana dengan kondisi objek Lelang?", 
        answer: "Untuk objek lelang yang dilelang di Djubli adalah unit apa adanya baik fisik kendaraan maupun dokumen / legalitas kendaraan.",
        customElementAnswer: false
    },
    { 
        question: "Bagaimana dengan kelengkapan dokumen objek lelang?", 
        answer: "Untuk mengetahui kelengkapan dokumen kendaraan atau objek lelang lain, kami menyediakan keterangan pada detail informasi objek lelang di website ataupun aplikasi Djubli, dan juga pada daftar objek lelang yang disebut dengan daftar lot yang kami bagikan di lokasi lelang. Anda juga dapat datang langsung lokasi kami untuk melihat salinan data yang kami sediakan di bagian informasi.",
        customElementAnswer: false
    },
    { 
        question: "Bagaimana cara melakukan registrasi?", 
        answer: <>
            <ul>
                <li>Calon peserta lelang dapat melihat daftar unit yang lelang di Website / Aplikasi Djubli yang dapat didownload di Playstore maupun AppStore</li>
                <li>Calon peserta lelang melakukan registrasi dengan kelengkapan email, nomor telfon dan KTP</li>
            </ul>
        </>,
        customElementAnswer: true,
    },
    { 
        question: "Bagaimana Cara Memenangkan Unit Objek Lelang Yang Diinginkan?", 
        answer: <>
            <ul>
                <li>Setelah registrasi dan memiliki username di aplikasi Djubli, Peserta lelang menyerahkan uang jaminan atau deposit (Rp 5 Juta / Unit mobil dan Rp 1 Juta / Unit motor) untuk pembelian Token agar dapat melakukan penawaran</li>
                <li>Calon peserta melakukan open house untuk pengecekan unit lelang dan mengikuti lelang melalui Aplikasi / Website Djubli</li>
                <li>Peserta Lelang memberikan penawaran terhadap unit yang diinginkan</li>
                <li>Apabila penawarannya sudah tertinggi pada waktu yang telah ditentukan maka ditentukan sebagai pemenang</li>
            </ul>
        </>,
        customElementAnswer: true,
    },
    { 
        question: "Apakah anda harus hadir saat lelang berlangsung?", 
        answer: "Saat lelang berlangsung Peserta Lelang tidak harus hadir dan dapat mengikuti lelang secara Online melalui Gadget masing - masing.",
        customElementAnswer: false
    },
    { 
        question: "Apa Perbedaan Live Auction dan Timed Auction", 
        answer: <>
            <ul>
                <li>Live Auction adalah lelang yang dilakukan Lot per Lot, menunggu satu lot selesai sampai penawaran tertinggi dan tidak ada yang berani menawar lagi. Jika sudah selesai dilanjutkan Lot berikutnya.</li>
                <li>Timed Auction adalah lelang yang sudah ditentukan waktu penawarannnya, dilakukan secara bersamaan untuk semua lot yang dilelang, peserta bisa langsung melakukan penawaran kepada objek yang diminati tanpa menunggu lot per lot seperti Live Auction.</li>
            </ul>
        </>,
        customElementAnswer: true,
    },
    { 
        question: "Apakah Akun Untuk Mengikuti Live Auction berbeda dengan Timed Auction?", 
        answer: "Dengan melakukan registrasi di Website / Aplikasi Djubli, Calon Peserta Lelang memiliki satu akun yang dapat digunakan untuk semua opsi lelang, baik Live Auction /  Timed Auction.",
        customElementAnswer: false
    },
    { 
        question: "Bagaimana Cara Melunasi Objek Lelang Yang Dimenangkan?", 
        answer: "Pemenang Lelang akan diberikan informasi jumlah nominal rupiah yang harus dibayarkan pada formulir Konfirmasi Pemenang Lelang, disertai dengan Nomor Rekening tujuan. Formulir Konfirmasi Pemenang Lelang dikirimkan melalui email yang telah di registrasi sebagai akun DjuBli.",
        customElementAnswer: false
    },
    { 
        question: "Berapa Lama Masa Pelunasan Objek Yang Dimenangkan", 
        answer: "Untuk masa pelunasan objek yang dimenangkan lelang maksimal 3 Hari Kerja. Jika melebihi waktu ini, maka dianggap wanprestasi dan uang deposit hangus.",
        customElementAnswer: false
    },
    { 
        question: "Kapan Dokumen Dari Objek Lelang Bisa Diambil?", 
        answer: "Informasi kapan tersedianya dokumen kendaraan atau objek lelang lain sudah tertulis dalam keterangan daftar lot di lokasi lelang dan di halaman detail objek lelang di website dan aplikasi Djubli. Perhitungan hari ketersediaan dokumen kendaraan dimulai setelah hari lelang.",
        customElementAnswer: false
    },
    { 
        question: "Kapan Pemenang Dapat Mengambil Objek Yang Dimenangkan?", 
        answer: "Pemenang Lelang dapat mengambil objek pemenang setelah melakukan pelunasan.",
        customElementAnswer: false
    },
]

export const AUCTION_BUY_TOKEN_STEP = [
    { step: 1, desc: `Daftar (Sign Up) Di Website atau Aplikasi DjuBli` },
    { step: 2, desc: `Konfirmasi dan Verifikasi Ikut Lelang Melalui CS DjuBli (Verifikasi->Email dan KTP)` },
    { step: 3, desc: `Transfer Uang pembelian token ke BCA 7140533500 an PT BINTANG PHOENIX SAKTI` },
    { step: 4, desc: `Kirim Bukti Transfer ke CS DjuBli` },
    { step: 5, desc: `Token akan aktif dan diberikan notifikasi melalui WA dan Email` },
]